import { IconName, IconPrefix } from '@fortawesome/fontawesome-common-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, { FC } from 'react'
import Modal from '../common/Modal'

interface Props {
  list: {
    service_name: string
    icon: string | null
    icon_color: string | null
  }[]
  closeCallback: VoidFunction
  isDisplay: boolean
  closeable?: boolean
}

const UseLabelModal: FC<Props> = (props) => {
  const {
    list,
    closeCallback,
    isDisplay,
    closeable,
  } = props

  return (
    <Modal
      show={isDisplay}
      wrapperClass="effort_label"
      closeCallback={closeCallback}
      closeable={closeable}
    >
      <>
        <div
          style={{
            marginBottom: "24px",
          }}
        >
          業務仕分け対象アプリケーション一覧
        </div>
        <div
          style={{
            display: "flex",
            flexWrap: "wrap",
            gap: "4px",
          }}
        >
          {
            list.map((value) => (
              <div
                key={`use_service_${value.service_name}`}
                style={{
                  fontSize: "16px",
                  padding: "4px 8px",
                  display: "flex",
                }}
              >
                <div
                  style={{
                    color: value.icon_color || "#666666",
                    marginRight: "4px",
                  }}
                >
                  {
                    value.icon ? (
                      <FontAwesomeIcon
                        icon={[value.icon.split(" ")[0] as IconPrefix, value.icon.split(" ")[1] as IconName]}
                        fixedWidth
                      />
                    ) : (
                      <FontAwesomeIcon
                        icon={["fas", "check-circle"]}
                        fixedWidth
                      />
                    )
                  }
                </div>
                {value.service_name}
              </div>
            ))
          }
        </div>
      </>
    </Modal>
  )
}

UseLabelModal.defaultProps = {
  closeable: true,
}

export default UseLabelModal
